<ng-container *ngFor="let toolbarItem of toolbar; let lastToolbarItem = last; trackBy: trackByIndex">
    <ng-container *ngFor="let item of toolbarItem; let lastItem = last; trackBy: trackByIndex">
        <div class="FcAgEditorBubbleMenu__Icon" [ngClass]="{'FcAgEditorBubbleMenu__Icon--Active': this.activeItems.includes(item),
  'FcAgEditor--Disabled': !this.execulableItems.includes(item)}" (mousedown)="onClick($event, item)"
             *ngIf="toggleCommands.includes(item)" [title]="getTitle(item)" [innerHTML]="getIcon(item)">
        </div>
        <div class="FcAgEditorBubbleMenu__Seperator" *ngIf="lastItem && !lastToolbarItem"></div>
    </ng-container>
</ng-container>
